// @ts-nocheck -- staged migration: add explicit types before removing this directive.
export const BATCH_SIZE = 25;

function shuffle(array) {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
}

export function buildQueue(pool, words, progress) {
    const filtered =
        pool === "all"
            ? words
            : pool === "learned"
            ? words.filter((word) => progress[word.id] === "learned")
            : words.filter((word) => progress[word.id] !== "learned");
    return shuffle(filtered).slice(0, BATCH_SIZE);
}
